var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-cursor mb-2",on:{"click":_vm.back}},[_c('span',[_c('BIconChevronLeft')],1),_c('span',[_vm._v(_vm._s(_vm.BackVal))])])}
var staticRenderFns = []

export { render, staticRenderFns }